import logo from "./logo.svg";
import "./App.css";
import { createBrowserRouter, RouterProvider, Outlet } from "react-router-dom";
import HomePage from "./pages/Home";
import ProductDetailPage from "./pages/ProductDetail";
import ShopCollectionPage from "./pages/ShopCollection";
import ShopDefaultPage from "./pages/ShopDefault";
import AccountPage from "./pages/Account";
import OrdersDetailsPage from "./pages/OrdersDetails";
import AccountLoginPage from "./pages/AccountLogin";
import CartPage from "./pages/Cart";
import CheckoutPage from "./pages/Checkout";
import PaymentSuccessPage from "./pages/PaymentSuccess";
import ContactPage from "./pages/Contact";
import MobileAppBanner from "./components/MobileAppBanner";
import GoogleAnalytics from "./components/GoogleAnalytics";
import { LanguageProvider } from "./context/LanguageContext";

// Wrapper component to provide LanguageContext inside RouterProvider
function AppLayout() {
  return (
    <LanguageProvider>
      <GoogleAnalytics />
      <Outlet />
      <MobileAppBanner />
    </LanguageProvider>
  );
}

function App() {
  const router = createBrowserRouter([
    {
      element: <AppLayout />,
      children: [
        {
          path: "/",
          element: <HomePage />,
        },
        {
          path: "/product/:id",
          element: <ProductDetailPage />,
        },
        {
          path: "/shop/collection",
          element: <ShopCollectionPage />,
        },
        {
          path: "/shop/default",
          element: <ShopDefaultPage />,
        },
        {
          path: "/account",
          element: <AccountPage />,
        },
        {
          path: "/account/orders",
          element: <AccountPage />,
        },
        {
          path: "/account/details",
          element: <AccountPage />,
        },
        {
          path: "/account/address",
          element: <AccountPage />,
        },
        {
          path: "/account/wishlist",
          element: <AccountPage />,
        },
        {
          path: "/account-orders-details/:orderId",
          element: <OrdersDetailsPage />,
        },
        {
          path: "/account-login",
          element: <AccountLoginPage />,
        },
        {
          path: "/cart",
          element: <CartPage />,
        },
        {
          path: "/checkout",
          element: <CheckoutPage />,
        },
        {
          path: "/payment-success",
          element: <PaymentSuccessPage />,
        },
        {
          path: "/contact",
          element: <ContactPage />,
        },
        // Arabic routes with /ar prefix
        {
          path: "/ar",
          element: <HomePage />,
        },
        {
          path: "/ar/product/:id",
          element: <ProductDetailPage />,
        },
        {
          path: "/ar/shop/collection",
          element: <ShopCollectionPage />,
        },
        {
          path: "/ar/shop/default",
          element: <ShopDefaultPage />,
        },
        {
          path: "/ar/account",
          element: <AccountPage />,
        },
        {
          path: "/ar/account/orders",
          element: <AccountPage />,
        },
        {
          path: "/ar/account/details",
          element: <AccountPage />,
        },
        {
          path: "/ar/account/address",
          element: <AccountPage />,
        },
        {
          path: "/ar/account/wishlist",
          element: <AccountPage />,
        },
        {
          path: "/ar/account-orders-details/:orderId",
          element: <OrdersDetailsPage />,
        },
        {
          path: "/ar/account-login",
          element: <AccountLoginPage />,
        },
        {
          path: "/ar/cart",
          element: <CartPage />,
        },
        {
          path: "/ar/checkout",
          element: <CheckoutPage />,
        },
        {
          path: "/ar/payment-success",
          element: <PaymentSuccessPage />,
        },
        {
          path: "/ar/contact",
          element: <ContactPage />,
        },
      ],
    },
  ]);

  return <RouterProvider router={router} />;
}

export default App;
